export default __webpack_public_path__ + "static/media/IFFCO.beea24a7.png";